// src/i18n/useStrongTypeTranslation.ts
import { useI18n } from "vue-i18n";
import type { TranslationKey } from "./types";

type TranslationParams = Record<string, string | number>;

export function useStrongTypedI18n() {
  const i18n = useI18n();

  /**
   * Strongly-typed translation function
   * @param key - Translation key (e.g., 'common.actions', 'pages.home.header.actions.logout')
   * @param params - Optional parameters for interpolation
   */
  const t = (key: TranslationKey, params?: TranslationParams): string => {
    if (import.meta.env.DEV && !i18n.te(key)) {
      console.error(`❌ Missing translation key: "${key}"`);
    }
    return i18n.t(key, params);
  };

  /**
   * Check if translation key exists
   */
  const te = (key: TranslationKey): boolean => {
    return i18n.te(key);
  };

  /**
   * Get translation message (returns object for nested keys)
   */
  const tm = (key: TranslationKey) => {
    return i18n.tm(key);
  };

  return {
    t,
    te,
    tm,
    d: i18n.d,
    n: i18n.n,
    locale: i18n.locale,
    rt: i18n.rt,
  };
}
